export default __webpack_public_path__ + "static/media/logo_autopass_for_business_white.7c30e0b3.svg";